// Renders agent-created props (the public-goods economy) into a GreyboxLocationScene at runtime — the
// client's first runtime object-spawn path. Mirrors RemoteAgentDriver: binds GlobalInfo server-* events
// in the constructor, auto-destroys on scene SHUTDOWN/DESTROY. Objects arrive via the location snapshot
// (server-snapshot.objects) and via live world-object-spawn / world-object-remove.

import GlobalInfo from '../GlobalInfo'
import { floatFeedback } from '../Scenes/feedback'
import { TILE_SIZE } from '../Scenes/greybox/greyboxTileset'
import type GreyboxLocationScene from '../Scenes/greybox/GreyboxLocationScene'
import type { DynamicObjectPublic } from './protocol'

export class DynamicObjectDriver {
    private handlers: { ev: string; fn: (...a: any[]) => void }[] = []

    constructor(private scene: GreyboxLocationScene, private location: string) {
        this.bind('server-snapshot', (p: any) => {
            if (p.location !== this.location) return
            for (const o of (p.objects ?? []) as DynamicObjectPublic[]) this.scene.spawnDynamicObject(o)
        })
        this.bind('server-world-object-spawn', (p: { object: DynamicObjectPublic; announce?: boolean }) => {
            if (p.object.location !== this.location) return
            this.scene.spawnDynamicObject(p.object)
            if (p.announce) {
                const wx = p.object.tile.x * TILE_SIZE + TILE_SIZE / 2
                const wy = p.object.tile.y * TILE_SIZE
                floatFeedback(this.scene, wx, wy, `✨ ${p.object.creatorName} a créé\n${p.object.label}`)
            }
        })
        this.bind('server-world-object-remove', (p: { objectId: string; location: string }) => {
            if (p.location !== this.location) return
            this.scene.removeDynamicObject(p.objectId)
        })
        this.scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.destroy())
        this.scene.events.once(Phaser.Scenes.Events.DESTROY, () => this.destroy())
    }

    private bind(ev: string, fn: (...a: any[]) => void): void {
        GlobalInfo.on(ev, fn)
        this.handlers.push({ ev, fn })
    }

    destroy(): void {
        for (const { ev, fn } of this.handlers) GlobalInfo.off(ev, fn)
        this.handlers = []
    }
}
